module.exports = __webpack_public_path__ + "img/background2.65af87c7.png";